import ENDPOINTS from '../../constants/apiEndPoints';
import {axiosInstance} from '../axiosInstance';

export const handleCreatePermissionService = async (payload: any) => {
  const response = await axiosInstance.post(
    ENDPOINTS.GET_CREATE_PERMISSION,
    payload,
  );
  return response?.data;
};

export const handleGetAllPermissionsService = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_PERMISSION);
  return response?.data;
};

export const handleUpdatePermissionService = async (
  id: string,
  payload: any,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.GET_UPDATE_DELETE_PERMISSION(id),
    payload,
  );
  return response?.data;
};

export const handleDeletePermissionService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.GET_UPDATE_DELETE_PERMISSION(id),
  );
  return response?.data;
};

export const handleGetAllGroupedPermissionsService = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_GROUPED_PERMISSION);
  return response?.data;
};

export const handleGetPermissionsTreeService = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_PERMISSION_TREE);
  return response?.data;
};
